import React from 'react';

const Error = () => {
  return (
    <div className='display-error'>
      <i className='massive redo alternate icon' />
      <h1>Unable to get your location.</h1>
    </div>
  );
};

export default Error;
